import { useIntl } from 'react-intl';
import { useMutation } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { queryClient } from 'src/config';
import { postRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

const createSignByUcm = async (contractUuid: string) => {
  return await postRequest<RequestSimplifiedData>(
    API.POST.createSignByUcm(contractUuid),
    null,
    { headers: { Accept: 'application/vnd.falcon.v2+json' } },
  );
};

export const useCreateSignByUcm = () => {
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createSignByUcm,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.signatureRequested));
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.CONTRACTS],
      });
    },
    onError: handleError,
  });
};
